import IJitRepository from '../domain/IJitRepository';
import { LoadMapper } from '../infrastructure/mappers/load.mapper';
import jitRepository from '../infrastructure/repositories/JitRepository';

class CreateJitTransitService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ body }: { body: any }) {
    const dto = LoadMapper.toCreateDTO(body);
    return this._jitRepository.createJitTransit({ body: dto });
  }
}

export default new CreateJitTransitService({
  repository: jitRepository
});

export { CreateJitTransitService };
